let State = {
  createStore(reducers, initState) {
    let promiseMiddleware = function (store) {
      return function (next) {
        return function (action) {
          if (typeof action.then === "function") {
            return action.then(store.dispatch).catch(function (err) {
              console.error(err.toString());
            });
          }

          return next(action);
        };
      };
    };

    let reducer = function (state, action) {
      let fn = reducers[action.type];

      if (fn) {
        return fn(state, action);
      }

      return state;
    };

    return Redux.createStore(reducer, initState, Redux.applyMiddleware(promiseMiddleware));
  },

  bindActions(actions, store) {
    return Redux.bindActionCreators(actions, store.dispatch);
  }
};


module.exports = State;